import { observable, runInAction } from "mobx"

import { batchInfo } from "@/lib/apiClient/client.ts"
import { Model } from "@/lib/Model.ts"

import type { ChatMessageModel } from "@/components/Chat/ChatModel.ts"
import type { AiChatMessage, AiChatMessageContent } from "@/lib/client/generated/TypeDefinitions.ts"
import type { Queries } from "@/lib/queries.ts"
import type { IObservableValue } from "mobx"


export class ArchivedMessagesBlockModel extends Model {
  private readonly messageIds: string[]

  readonly data: IObservableValue<ChatMessageModel[] | null>
  readonly isExpanded: IObservableValue<boolean>

  constructor(
    private readonly queries: Queries,
    private readonly taskId: string,
    content: AiChatMessageContent.ArchivedBlockGroup,
    private readonly createMessages: (messages: AiChatMessage[]) => Promise<ChatMessageModel[]>
  ) {
    super("ArchivedMessagesBlockModel")

    this.messageIds = content.blocks.map((it) => it.messageId)

    this.data = observable.box<ChatMessageModel[] | null>(null)
    this.isExpanded = observable.box(false)
  }

  readonly toggleExpand = async () => {
    const wasExpanded = this.isExpanded.get()
    runInAction(() => {
      this.isExpanded.set(!wasExpanded)
    })

    if (!wasExpanded && !this.data.get()) {
      await this.loadData()
    }
  }

  private readonly loadData = async () => {
    if (this.isLoading.get()) return

    runInAction(() => {
      this.isLoading.set(true)
    })

    try {
      const batch = await this.queries.archivedMessages(
        this.taskId,
        batchInfo(1000),
        this.messageIds,
        "FromOldestToNewest",
      )

      const messageVMs = await this.createMessages(batch.data)

      runInAction(() => {
        this.data.set(messageVMs)
      })
    } finally {
      runInAction(() => {
        this.isLoading.set(false)
      })
    }
  }
}